module.exports = __webpack_public_path__ + "static/img/s09.a2169839.png";